export default {
	routes: {
		home: {
			path: '/',
			name: 'home',
		},

		menu: {
			path: '/menu/',
			name: 'menu',
			footer_column1: true,
		},

		muramoney: {
			path: '/muramoney/',
			name: 'muramoney',
			footer_column1: true,
		},

		aboutUs: {
			path: '/about-us/',
			name: 'aboutUs',
			footer_column2: true,
		},

		contactUs: {
			path: '/contact-us/',
			name: 'contactUs',
			footer_column2: true,
		},

		blog: {
			path: '/blog/',
			name: 'blog',
			footer_column2: true,
		},

		privacyPolicy: {
			path: '/privacy-policy/',
			name: 'privacyPolicy',
			footer_column2: true,
		},

		unsubscribe: {
			path: '/unsubscribe/',
			name: 'unsubscribe',
		},

		notFound: {
			path: '/not-found/',
			name: 'notFound',
		},

		// ======================== Auth ======================== //
		signIn: {
			path: '/sign-in/',
			name: 'signIn',
			footer_column1: true,
		},

		signUp: {
			path: '/sign-up/',
			name: 'createAccount',
			footer_column1: true,
		},

		forgotPassword: {
			path: '/forgot-password/',
			name: 'forgotPassword',
		},

		resetPassword: {
			path: '/reset-password/',
			name: 'resetPassword',
		},

		verifyPhone: {
			path: '/verify-phone/',
			name: 'verifyPhone',
			completesVerification: 'phone',
			private: true,
			pendingRegistrationExempt: true,
		},

		// ======================== User ======================== //
		account: {
			path: '/account/',
			name: 'account',
			private: true,
		},
		accountAddresses: {
			path: '/account/addresses/',
			name: 'addresses',
			private: true,
		},
		accountBalance: {
			path: '/account/balance/',
			name: 'accountBalance',
			private: true,
		},
		orderHistory: {
			path: '/account/order-history/',
			name: 'orderHistory',
			private: true,
		},
		myCards: {
			path: '/account/my-cards/',
			name: 'myCards',
			private: true,
		},
		cart: {
			path: '/cart/',
			name: 'cart',
		},
		checkout: {
			path: '/checkout/',
			name: 'checkout',
			private: true,
		},
	},
};
